<template>
    <v-container fluid>
        <v-flex lg-12><h3 class="font-weight-bold">User Profile</h3></v-flex>

        <v-layout class="pa-2" mt-2 row v-if="user.name" wrap>
            <v-flex md6>
                <v-card class="pa-2">
                    <v-list class="pa-0" two-line>
                        <list-item-detail :sub_title="user.name" :divider="true" icon="mdi-account" :inset="true"
                                          title="Full Name"></list-item-detail>

                        <list-item-detail :sub_title="user.mobile_number" :divider="true" icon="phone" :inset="true"
                                          title="Mobile Number"></list-item-detail>

                        <list-item-detail :sub_title="user.email" :divider="true" icon="mail" :inset="true"
                                          title="Email"></list-item-detail>

                        <list-item-detail :sub_title="user.position" :divider="true" icon="mdi-alpha-p-box" :inset="true"
                                          title="Position"></list-item-detail>

                        <list-item-detail :sub_title="user.trekking_agency.name" :divider="true" icon="mdi-alpha-t-box"
                                          :inset="true"
                                          title="Agency Name"></list-item-detail>

                        <list-item-detail :sub_title="user.trekking_agency.address" icon="mdi-map-marker"
                                          title="Address"></list-item-detail>
                    </v-list>
                </v-card>
            </v-flex>
            <v-flex md6 pl-2>
                <v-card class="elevation-1 pa-3">
                    <v-card-text class="pb-0">
                        <div id="label"><h3>Change Password</h3></div>
                        <v-form lazy-validation ref="userProfile" v-model="valid">
                            <v-text-field
                                    :rules="[rules.required]"
                                    :append-icon="passwordShowOld ? 'visibility_off' : 'visibility'"
                                    :error-messages="oldPasswordErrors"
                                    :type="passwordShowOld ? 'text' : 'password'"
                                    @click:append="passwordShowOld = !passwordShowOld"
                                    class="my-3"
                                    label="Current Password"
                                    outlined
                                    prepend-inner-icon="fingerprint"
                                    v-model="formData.old_password"
                            ></v-text-field>
                            <v-text-field
                                    :rules="[rules.required]"
                                    :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                                    :error-messages="newPasswordErrors"
                                    :type="passwordShow ? 'text' : 'password'"
                                    @click:append="passwordShow = !passwordShow"
                                    class="my-3"
                                    label="New Password"
                                    outlined
                                    prepend-inner-icon="fingerprint"
                                    v-model="formData.password"
                            ></v-text-field>
                            <v-text-field
                                    :rules="[rules.required]"
                                    :append-icon="confirmPasswordShow ? 'visibility_off' : 'visibility'"
                                    :error-messages="confirmPasswordErrors"
                                    :type="confirmPasswordShow ? 'text' : 'password'"
                                    @click:append="confirmPasswordShow = !confirmPasswordShow"
                                    class="my-3"
                                    label="Confirm New Password"
                                    outlined
                                    prepend-inner-icon="fingerprint"
                                    v-model="formData.password_confirmation"
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions style="padding: 1px 8px;" >
                        <v-spacer></v-spacer>
                        <v-btn
                                :loading="loading"
                                @click="createNewPassword"
                                class="white--text mr-1"
                                color="primary">Change
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {validationMixin} from "../mixins/validationMixin";
    import ListItemDetail from '../components/ListItemDetail'

    export default {
        components: {ListItemDetail},
        name: "Profile",
        data: () => ({
            profileImage: require("../../public/logo-min.png"),
            user_profile: {},
            form: false,
            snackbar: false,
            errors: [],
            valid: true,
            notificationMessage: "",
            formData: {},
            passwordShow: false,
            confirmPasswordShow: false,
            passwordShowOld: false,
            oldPasswordErrors:[],
            newPasswordErrors:[],
            confirmPasswordErrors:[],
        }),
        mixins: [validationMixin],
        computed: {
            ...mapGetters("AuthUser", ["loading", "user"]),
        },
        methods: {
            ...mapActions("AuthUser", ["resetState", "changePassword"]),

            validatePassword(){
                this.oldPasswordErrors = [];
                this.newPasswordErrors = [];
                this.confirmPasswordErrors = [];

                if(this.formData.password && this.formData.old_password && this.formData.old_password === this.formData.password)
                    this.newPasswordErrors.push("Old password and new password should be different");
                if(this.formData.password_confirmation && this.formData.password && this.formData.password_confirmation !== this.formData.password)
                    this.confirmPasswordErrors.push("new password and confirmation password should be same");

                if(this.oldPasswordErrors.length === 0 && this.newPasswordErrors.length === 0 && this.confirmPasswordErrors.length === 0)
                    return true;
            },
            createNewPassword() {
                if (this.$refs.userProfile.validate() && this.validatePassword()) {
                    this.changePassword(this.formData)
                        .then(() => {
                            this.formData = {};
                            this.errors = null;
                            this.$store.commit("Notification/showSuccess", "Password changed successfully");
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                            }
                        })
                        .finally(f => {
                        });
                }
            },

        },
        mounted() {
        }
    };
</script>



